export interface FilterField {
  fieldId: string | undefined
  value: object
  fields?: Record<string, unknown> | null
}

export type FilterConfigProps = {
  afterField?: string
  beforeField?: string
  choices?: { id: string | boolean | number; name: string }[]
} & Record<string, unknown>

export interface FilterConfig {
  id: string
  name: string
  field: React.ElementType
  relatedFields?: string[]
  parseInitialValue?: (filterValues: object) => Record<string, unknown>
  props?: FilterConfigProps
}

export interface SuggestedFilter {
  id: string
  name: string
}

export interface SortOption {
  value: string
  label: string
}

export interface OrderOption {
  value: 'asc' | 'desc'
  label: string
}

export const BOOLEAN_CHOICES = [
  { id: true, name: 'Is' },
  { id: false, name: 'Is not' },
]

export const DATE_CHOICES = [
  { id: 0, name: 'Is on or after' },
  { id: 1, name: 'Is on or before' },
]
